// pdf.js runtime assets, served from our own origin (security audit M6).
// The worker is a Vite-hashed asset; cMaps and standard fonts are copied out
// of node_modules by the `pdfjs-assets` plugin in vite.config.ts under a
// versioned path, so a pdfjs-dist upgrade never reads a stale cached file.
import workerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";

declare const __PDFJS_ASSET_BASE__: string;

export const PDFJS_WORKER_SRC = workerUrl;
export const PDFJS_CMAP_URL = `${__PDFJS_ASSET_BASE__}cmaps/`;
export const PDFJS_STANDARD_FONT_DATA_URL = `${__PDFJS_ASSET_BASE__}standard_fonts/`;
